import React from 'react'
import {Container} from 'react-bootstrap';
import withAuth from '../components/authHOC';
import NotificationsTable from '../components/NotificationsTable';

const NotificationsPage = () => {
    
  return (
       <Container fluid id='users-container'>
       
        <NotificationsTable></NotificationsTable>
    </Container>
  )
}
export default withAuth (NotificationsPage, ['admin', 'agent'])